import { useEffect } from "react";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useCookie } from "../useCookie";
import { useQueryParam } from "../useQueryParam";
import { useDebounce } from "../useDebounce";
import { toQuery } from "../../helpers/general";
import apiService from "../../service/apiService";

const PAGE_SIZE = 20;

export const useMultiPlaceAdminInvoicesQuery = () => {
  const { token } = useCookie("vToken");
  // const [searchQuery, handleSearch] = useState("");
  const [searchParams] = useSearchParams();

  const query = searchParams?.get("search") ?? "";
  const currentPage = searchParams?.get("page") ?? "1";

  const searchQuery = useDebounce(query, 1000);
  const { addMultiple } = useQueryParam();

  useEffect(() => {
    addMultiple({ search: searchQuery, page: "1" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  const endPoint = `invoices/${toQuery({
    page: currentPage,
    limit: PAGE_SIZE,
    // query: searchQuery
  })}`;

  const queryDependencies = ["getAllOffers", endPoint];
  const { data, isLoading } = useQuery(queryDependencies, () => {
    return apiService.MakeGetRequest(endPoint, token);
  });

  return {
    invoices: data?.items as MultiPlaceAdminInvoice[],
    isLoading,
    totalPages: data?.meta?.totalPages,
    totalItems: data?.meta?.totalItems,
    currentPage,
  };
};
